import Vue from 'vue';
import Vuex from 'vuex';
import Shift from "@/views/shift/shift.module";
import Ratings from "@/views/ratings/ratings.module";
import Auth from "@/views/auth/auth.module";
import OfficeProfile from "@/views/office-profiles/office-profiles.module";
import Wizard from "@/views/wizard/wizard.module";
import DentalTemp from "@/views/dental-temps/dental-temps.module";
import SupportDashboard from '@/views/customer-support/dashboard.module';
import Vacancy from '@/views/vacancies/vacancies-module';
import Refer from '@/views/refer/refer.module';
import { VuexModule } from 'vuex-module-decorators';

interface State {
  Shift: VuexModule;
  Ratings: VuexModule,
  Auth: VuexModule,
  OfficeProfile: VuexModule,
  Wizard: VuexModule,
  DentalTemp: VuexModule,
  SupportDashboard: VuexModule,
  Vacancy: VuexModule,
  Refer: VuexModule
}

Vue.use(Vuex)

const initialState: State = JSON.parse(JSON.stringify({
  Shift: Shift.state,
  Ratings: Ratings.state,
  Auth: Auth.state,
  OfficeProfile: OfficeProfile.state,
  Wizard: Wizard.state,
  DentalTemp: DentalTemp.state,
  SupportDashboard: SupportDashboard.state,
  Vacancy: Vacancy.state,
  Refer: Refer.state
}));

export default new Vuex.Store({
  state: undefined,
  actions: {},
  modules: {
    Shift,
    Ratings,
    Auth,
    OfficeProfile,
    Wizard,
    DentalTemp,
    SupportDashboard,
    Vacancy,
    Refer
  },
  
  mutations: {
    reset(state: State) {
      Object.keys(state).forEach(key => {
        Object.assign(state[key as keyof State], initialState[key as keyof State])
      })
    }
  }
})
